import React, { useState,useEffect,useRef } from "react"
import ThumbsUp from '../Imgs/thumbs-up.svg'
import ThumbsDown from '../Imgs/thumbs-down.svg'
import Textarea from "@react/react-spectrum/Textarea"
import { addToast, Toast } from '@react/react-spectrum/Toast'
import Button from "@react/react-spectrum/Button"
import { useForm } from '@formcarry/react';
import axios from 'axios';
import './ThumbsUpDown.scss';
import close from "../Imgs/close-feedback.svg";
import CaptureAnalytics from '../analytics/CaptureAnalytics';
import { use } from "chai"

let showToast = false;
export default function ThumbsUpDown(props) {
    useEffect(() => {
        // Update the document title using the browser API
        getDate()
      }, []);
    const [comment, setComment] = useState('');
    const [active, setActive] = useState(false);  
    const [action, setAction] = useState("");
    const [error, setError] = useState("");
    const [location,setLocation] = useState([])
    const [ipv,setIpv] = useState('')
    const [date,setDate] = useState('');
    const thumbsUpContainer = useRef(null);
    const submitCTA = useRef(null);
    const [feedback, feedbackChange] = useState(false);

    useEffect(() => {
        if(submitCTA.current != null)
        {
            if(comment === "" || comment.length === 1){
                submitCTA.current.buttonRef.disabled = true;
                if(comment === "") {
                    submitCTA.current.buttonRef.className = submitCTA.current.buttonRef.className + 'is-disabled';
                }
            }
            else{
                submitCTA.current.buttonRef.disabled = false;
                submitCTA.current.buttonRef.className = submitCTA.current.buttonRef.className.replace('is-disabled','');
            }
        }
    }, [comment]);
    if (showToast) {
        showToast = false;
        addToast(
            <Toast className="thumbsupToast" closable {...props} variant="success">
              Submitted. Thanks for your feedback.
            </Toast>,10000,thumbsUpContainer.current.parentNode.parentNode
          );          
        //return <div className="thumbsUp">Thank you for your feedback!</div>
    }
    useEffect(() => {
        setTimeout(() => {feedbackChange(true)}, 30000);
    }, [])

    const getDate = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        let mins = today.getMinutes().length === 1 ? `0${today.getMinutes()}`  : today.getMinutes()
        let time = `${today.getHours()}:${mins}`
        today = mm + '/' + dd + '/' + yyyy;
        setDate(`${today} ${time}`)
    }
    
    const handleThumbsUp = (action) => {        
        setAction(action);
        setActive(true);
        sendActivationAnalytic('feedback',(action==='up')?'isUseful':'notUseful');
    }
    const handleCancel = (type) => {
       // getDate();
        setActive(false);
        if (type === 'submit') {
            showToast = true;
            sendActivationAnalytic('sendFeedback',(action==='up')?'isUseful':'notUseful',comment);
        }
    }
    
    const handleComment = e => {        
        setComment(e);
    }

    const sendActivationAnalytic = (type, eventsubtype, eventValue) => {
		const captureAnalytics = new CaptureAnalytics(window.ENV);
        captureAnalytics.initAnalytics();
        let eventObj;
		switch (type) {
            case 'feedback':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Feedback',
                    type: 'click',
                    subType: eventsubtype
                };
                break;
            case 'sendFeedback':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Feedback',
                    type: 'click',
                    subType: eventsubtype,
                    value: eventValue
                };
                break;    
        }
        captureAnalytics.genericAnalyticEvent(eventObj);
	}
 

    const form = () => {
        let errorMsg = null;
        if (comment.length === 1)
        {
            errorMsg = (<p className="errorMsg">Please enter a comment at least 2 characters long.</p>);
        }
        return (
            <div className={active ? "activeThumb thumbsUpForm" : "hidden thumbsUpForm"}>
                <div>
                    <form>
                        <h1> {(action == "up") ? "Thanks! We'd appreciate hearing more about your experience. How will you use the pattern you made here?" : "Can you please share what didn't work or how we could improve? How would you like to use the patterns made here?"} </h1>
                        <input style = {{display:'none'}} name ="page" value = {props.title}></input>
                        <input style={{ display: "none" }} name="date" value={date}></input>
                        <Textarea style={{ display: "none" }} name="location" value={location}/>
                        <Textarea style={{ display: "none" }} name="IPv4" value={ipv}/>
                        <Textarea name={action} onChange={handleComment} value={comment} placeholder="Enter your comments here..." />
                        {errorMsg}
                        <div className="thumbButtons">
                            <Button type="button" onClick={handleCancel}>Cancel</Button>
                            <Button ref={submitCTA} disabled={comment===""} type="button" variant="cta" onClick={()=>{handleCancel('submit');return false;}}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    const feedbackComponent = feedback ? (<>
        <div className="thumbsUpWrapper">
            <button className="closeFeedback" onClick={() => {feedbackChange(false)}}><img src={close} /></button>
            <p>Is this useful?</p>
            <div className="icons">
                <div className="thumbsUpIcon" onClick={() => {handleThumbsUp("up")}}>
                    <img src={ThumbsUp}></img> <span>Yes</span>
                </div>
                <div className="thumbsDownIcon" onClick={() => handleThumbsUp("down")}>
                    <img src={ThumbsDown}></img> <span>No</span>
                </div>
            </div>
        </div>
        {form()}
        <div ref={thumbsUpContainer} className={props.title == "color" ? "thumbsUp thumbsUpColor" : "thumbsUp"}></div>
        </>) : null;

    return (
        <>{feedbackComponent}</>
    )

}